import { useMutation } from "@apollo/client/react";
import { TEST_TEMPLATE } from "../../mutations/invoiceInterpretationTemplates/testTemplate";

export const useTestTemplate = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [testTemplate, { data, loading, error }] = useMutation(TEST_TEMPLATE, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [],
    awaitRefetchQueries: true,
  });

  return { testTemplate, data, loading, error };
};
